import { getStoreId } from "$/hooks/use-store-information"
import storeAccountQueries from "$/lib/queries/store-account-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/user-accounts")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(storeAccountQueries.overview(storeId))
    }
    return { crumb: "alfred.settings.nav.userAccounts.label" }
  },
})
